/**
 * Validates that a given URL string is a valid absolute HTTP or HTTPS URL.
 * Throws an Error if the URL is invalid, empty, or uses an unsafe protocol (e.g. javascript:, data:, vbscript:).
 *
 * @param url The URL string to validate
 * @returns The validated absolute URL string (normalized)
 * @throws Error if the URL is not a valid http/https URL
 */
export function assertSafeUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string' || !url.trim()) {
    throw new Error('Ungültige oder fehlende URL angegeben.');
  }

  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    throw new Error(`Ungültiges URL-Format: "${url}"`);
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    throw new Error(`Unsicheres URL-Protokoll "${parsed.protocol}" in URL: "${url}"`);
  }

  return parsed.href;
}

